import _ from 'underscore';
import { addPoPFields, mapEnumValueForFilterBase, filterOptionsFromSchemaBase } from './schema-util-helper';

function geti18n() {
  return window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
}

//Map enum value like 'Eligible' For DeliveryStatus to "Enum.DeliveryStatus'Eligible'"
export function mapEnumValueForFilter(enumType, enumValue) {
  return mapEnumValueForFilterBase(enumType, enumValue);
}

// Notice !!! Do not update the rootSchema
// task 725601: update this to a meaningful name, as well as the buildFilters
export function filterOptionsFromSchema(rootSchema, mapEnumValue) {
  const schemaI18n = window.globalLegacyI18n.get('$/schema-i18n!campaign');
  const i18n = geti18n();

  return filterOptionsFromSchemaBase(rootSchema, mapEnumValue, i18n, schemaI18n);
}

export function appendPeriodOverPeriodFields(options, skipAddPopFields) {
  const i18n = geti18n();

  const optionsWithPop = skipAddPopFields === true ? options : addPoPFields(options);

  _.each(optionsWithPop.fields, (field) => {
    if (field.unlocalized) {
      field.title = i18n.getString(field.title);
      delete field.unlocalized;
    }
  });

  return optionsWithPop;
}
